class ComponentOverlay extends HTMLElement {
    constructor() {
        super();
        const _this = this;
        this.triggerElements = document.querySelectorAll(`[href="#${this.id}"]`);

        this.triggerElements.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.show();
            });
        });

        this.querySelector('.overlay-close').addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
        });

        const targetElement = this.querySelector('.overlay-popup-text');

        this.addEventListener('click', function(event) {
            if (this.classList.contains('hidden')) return;
            if (!targetElement.contains(event.target)) {
                _this.hide();
            }
        });
    }

    show() {
        this.classList.remove('hidden');
    }

    hide() {
        this.classList.add('hidden');
    }
}

document.addEventListener('shopify:block:select', (e)=>{
    if ( e.target.hasAttribute('data-js-overlay') ) {
        e.target.show();
    }
});
document.addEventListener('shopify:block:deselect', (e)=>{
    if ( e.target.hasAttribute('data-js-overlay') ) {
        e.target.hide();
    }
});

customElements.define('overlay-popup', ComponentOverlay);
